module.exports = __webpack_public_path__ + "static/panels-c8ba1076e6e3651c85fa23565d9eb40f.jpg";